module.exports = __webpack_public_path__ + "img/180h100_gluhoe.95586fa2.svg";